export default {
    breadcrumbs: {
        practice: 'Practice',
        practice_billing: 'Plan & Billing',
    },

    titles: {
        plan_billing: '{practiceName} Plan & Billing',
    },
    active_plan: 'Your active plan',
    cancel_subscription: 'Cancel subscription',
    change_plan: 'Change plan',
    join_free: 'Join Free',
    free_plan_confirm:
        'Continue on the Free plan for outbound referrals. Inbound receiving requires a paid plan after your trial.',
    pricing_eyebrow: 'PRICING',
    pricing_headline: 'Free outbound referrals forever. Paid plans unlock inbound.',
    pricing_footnote:
        '14-day Premium trial starts the moment your first inbound referral arrives — not at signup. Reverts to free Network if not upgraded.',
    billing_side_info: 'Connect with your network and make free outbound referrals.',
    billing_side_info_premium:
        'Preferred network for specialists and ancillary services. Build your network, make and receive quality referrals',
    appointment_fee: 'Extra inbound referrals beyond your plan allowance are billed per usage.',
    free_trial_ends: 'Free trial ends on {date}',
    upgrade_now: 'Upgrade to receive referrals',
    subscription_canceled: 'Subscription canceled. Your plan stays active until the end of the current billing period.',
    cancel_scheduled_notice: 'Your subscription is canceled. Your {plan} plan (billed {interval}) stays active until {date}.',
    resume_subscription: 'Resume subscription',
    subscription_resumed: 'Subscription resumed. Your {plan} plan will renew on {date}.',
    subscription_created: 'Subscribed to {planName} successfully!',
    billing_list: {
        item_1: 'Search and match providers',
        item_2: 'Make FREE referrals',
        item_3: 'Track referrals',
        item_4: '24/7 access to records',
        item_5: 'Provider-Provider messaging',
        item_6: 'Built your network',
        item_7: 'No contract needed',
        item_8: 'Engage new patients in mobile app',
        item_9: 'Send digital referrals to patients',
    },
    cancel_subscription_info:
        'If you cancel you will not be able to receive referrals on the platform. Your {activeBillingPeriod} {subscription} subscription fee will not be refunded. You will be downgraded to the Free plan where you can still search providers and services and make outbound referrals.',
    plan_type: 'PLAN TYPE',
    monthly: 'monthly',
    annually: 'annually',
    you_save: 'You save ',
    year: 'year',
    payment_form_list: {
        item_1: 'Search and match providers',
        item_2: 'Make and RECEIVE  referrals',
        item_3: 'Track referrals',
        item_4: '24/7 access to records',
        item_5: 'Provider-Provider messaging',
        item_6: 'Built your network',
        item_7: 'EMR integration',
        item_8: 'Referral analytics',
        item_9: 'Engage patients in mobile app',
        item_10: 'Send digital referrals to patients in app',
    },
    invite_new_member_warning:
        'On Starter, seats beyond the included five are $59/mo each ($472/yr). Professional and Practice Plus include unlimited seats. Office staff are free. Please confirm you agree.',
    add_location_warning:
        'Ancillary Premium bills each location on a graduated schedule ($199 / $169 / $149 per month). Please confirm you agree.',
    see_plans: 'See plans',
    registration_billing_info:
        'After your fourteen day Premium trial you can upgrade to a paid plan to keep receiving inbound referrals, or stay on Free for outbound referrals.',
    usage: {
        heading: 'Current usage',
        seats: 'Provider seats',
        locations: 'Locations',
        referrals: 'Referrals this period',
        referral_estimate: 'Referral cost estimate',
        next_invoice: 'Next invoice (est.)',
        period_end: 'Period ends',
    },
}
